import { autoinject } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import 'jquery';
import 'notify';
import { ShortDateValueConverter } from '../../resources/value-converters/short-date';

@autoinject
export class ExecutiveDashboardDetailsDialog {
    constructor(
        private shortDateConverter: ShortDateValueConverter,
        protected controller: DialogController,
        private api: WebApiService) {
    }

    period: string;
    millCode: string;
    entityType: string;
    details: any[] = [];

    activate(params) {
        this.period = params.period;
        this.millCode = params.millCode;
        this.entityType = params.entityType;
        return this.loadDetails();
    }

    loadDetails(): any {
        return this.api.get("Reports", "GetExecutiveDashboardProcessDuration", { period: this.period, millCode: this.millCode, entityType: this.entityType, rawData: true })
            .then(result => {
                this.details = JSON.parse(result.response);
            });
    }

    columnDefs: Array<any> = [
        {
            headerName: "Carrier", field: "legalname", filter: 'text',
            cellRenderer: (params) => {
                if (params.value != null) {
                    return `<a target="_new" href="/secure/work-carrier/${params.data.CarrierId}">${params.data.legalname + " (" + params.data.scaccode + ")"}</a>`;
                }
                return params.value;
            },
            pinned: 'left'
        },
        {
            headerName: "Request", width: 120, field: "requestNumber", filter: 'text',
            cellRenderer: (params) => {
                if (params.value != null) {
                    return `<a target="_new" href="/secure/requests/${params.data.requestId}">${params.data.requestNumber}</a>`;
                }
                return params.value;
            }
        },

        {
            headerName: "Req Opened", width: 160, field: "DivisionRequestDate", filter: 'date',
            cellRenderer: (params) => {
                return this.shortDateConverter.toView(params.value);
            }
        },
        {
            headerName: "Req Closed", width: 160, field: "RequestClosedDate", filter: 'date',
            cellRenderer: (params) => {
                return this.shortDateConverter.toView(params.value);
            }
        },
        // Division Requested Duration
        {
            headerName: "Division Requested On", width: 160, field: "DivisionRequestDate", filter: 'date',
            cellRenderer: (params) => {
                return this.shortDateConverter.toView(params.value);
            }
        },
        { headerName: "# Days", width: 100, field: "DivisionRequestDuration", filter: 'number' },
        // Link Sent Duration
        {
            headerName: "Link Sent On", width: 160, field: "LinkSentDate", filter: 'date',
            cellRenderer: (params) => {
                return this.shortDateConverter.toView(params.value);
            }
        },
        { headerName: "# Days", width: 100, field: "LinkSentDuration", filter: 'number' },
        // Carrier Registered Duration
        {
            headerName: "Carrier Registered On", width: 160, field: "CarrierRegisteredDate", filter: 'date',
            cellRenderer: (params) => {
                return this.shortDateConverter.toView(params.value);
            }
        },
        { headerName: "# Days", width: 100, field: "CarrierRegisteredDuration", filter: 'number' },
        // Packet Sent Duration
        {
            headerName: "Packet Sent On", width: 160, field: "PacketSentDate", filter: 'date',
            cellRenderer: (params) => {
                return this.shortDateConverter.toView(params.value);
            }
        },
        { headerName: "# Days", width: 100, field: "PacketSentDuration", filter: 'number' },
        // In Process Duration
        {
            headerName: "In Process On", width: 160, field: "InProcessDate", filter: 'date',
            cellRenderer: (params) => {
                return this.shortDateConverter.toView(params.value);
            }
        },
        { headerName: "# Days", width: 100, field: "InProcessDuration", filter: 'number' },
        // Insurance Review Duration
        {
            headerName: "Insurance Review On", width: 160, field: "InsuranceReviewDate", filter: 'date',
            cellRenderer: (params) => {
                return this.shortDateConverter.toView(params.value);
            }
        },
        { headerName: "# Days", width: 100, field: "InsuranceReviewDuration", filter: 'number' },
        // Insurance Complete Duration
        {
            headerName: "Insurance Complete On", width: 160, field: "InsuranceCompleteDate", filter: 'date',
            cellRenderer: (params) => {
                return this.shortDateConverter.toView(params.value);
            }
        },
        { headerName: "# Days", width: 100, field: "InsuranceCompleteDuration", filter: 'number' },
        {
            headerName: "Master Approved On", width: 160, field: "MasterApprovedDate", filter: 'date',
            cellRenderer: (params) => {
                return this.shortDateConverter.toView(params.value);
            }
        },
        { headerName: "Days to Completion", width: 160, field: "DaysToCompletion", filter: 'number' }

    ];

    gridOptions = {
        api: undefined,
        columnDefs: this.columnDefs,
        // onRowClicked: (e) => this.onRowClicked(e),
        //pagination controls require v9 or greater.
        pagination: true,
        paginationPageSize: 100,
        //paginationAutoPageSize : true
    };

    gridApi: any;

    exportGrid() {
        this.gridApi.exportDataAsCsv({
            fileName: "executive_dashboard_details.csv"
        });
    }

    onReady(event) {
        this.gridApi = this.gridOptions.api;
    }
}